import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts'
import { Settings } from '../constants/settings'
import Navigation from '../constants/enums/NavigationEnum'
import ExternalLinks from '../constants/enums/ExternalLinksEnum';

export const userManagerConfig: UserManagerSettings = {
  client_id: 'PersonalCabinet.WEBUI',
  redirect_uri: `${Settings.RootUrl}`,
  response_type: 'code',
  scope: 'openid profile PersonalCabinet.ApplicationAPI',
  authority: Settings.IdentityServer,
  automaticSilentRenew: false,
  //silent_redirect_uri: Navigation.AuthSilentRenew,
  filterProtocolClaims: true,
  loadUserInfo: true,
  monitorSession:true,
  // userStore: new WebStorageStateStore({ store: sessionStorage}), 
  userStore: new WebStorageStateStore({ store: localStorage }),
  post_logout_redirect_uri: `${ExternalLinks.CyfralServiceSite}`,

}; 



